/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerApiService } from './customer-api.service';
import { ConfigService } from 'src/app/service/config.service';

@Injectable({
  providedIn: 'root',
})
export class BookmarkApiService {
  constructor(
    private api: CustomerApiService,
    private config: ConfigService,
  ) {}

  getStars(): Observable<any> {
    return this.api.get('/v1/news_curation/mine?limit=300');
  }

  addStars(id: string): Observable<string> {
    return this.api.getText('/v1/news_curation/star', {
      project: this.config.appConfig.routing.apiproj,
      news_id: id,
    });
  }

  importStars(data: any): Observable<any> {
    return this.api.post('/v1/news_curation/import', data);
  }

  delStars(id: string): Observable<string> {
    return this.api.getText('/v1/news_curation/unstar', { news_id: id });
  }
}
